import { createApiAction } from 'helpers';

export const GET_DAO_TREASURY_INVESTMENTS = 'GET_DAO_TREASURY_INVESTMENTS';
export const GET_DAO_TREASURY_INVESTMENTS_SUCCESS = 'GET_DAO_TREASURY_INVESTMENTS_SUCCESS';
export const GET_DAO_TREASURY_INVESTMENTS_FAILURE = 'GET_DAO_TREASURY_INVESTMENTS_FAILURE';

export const CLEAR_DAO_TREASURY_INVESTMENTS_DATA = 'CLEAR_DAO_TREASURY_INVESTMENTS_DATA';

export const getDaoTreasuryInvestments = createApiAction(GET_DAO_TREASURY_INVESTMENTS);
